import React from "react";
import { Box, Paper } from "@mui/material";

export default function DashboardCard({ header, children, sx = {} }) {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                borderRadius: "24px",
                border: "1px solid #EEF2F7",
                background: "#FFFFFF",
                height: "100%",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                transition: "box-shadow .25s ease",
                "&:hover": {
                    boxShadow: "0px 8px 24px rgba(15,23,42,.06)",
                },
                ...sx,
            }}
        >
            {header}
            <Box sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
                {children}
            </Box>
        </Paper>
    );
}